import { render, staticRenderFns } from "./CustomMedicationForm.vue?vue&type=template&id=7601e40d"
import script from "./CustomMedicationForm.vue?vue&type=script&lang=js"
export * from "./CustomMedicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports